<template>
    <InsuranceBadgeBase v-bind="badgeProps" />
</template>

<script setup lang="ts">
import { BASE_INSURANCE_BADGE_MAP } from '@/components/shared/InsuranceBadge';
import { Insurance } from '@/types/closinglock.types.js';
import type { DsBadgeProps } from '@ds/badge/DsBadge.vue';
import { computed } from 'vue';
import InsuranceBadgeBase from './InsuranceBadgeBase.vue';

const props = defineProps<{
    insurance: Insurance;
}>();

const badgeProps = computed<DsBadgeProps>(() => {
    return BASE_INSURANCE_BADGE_MAP[props.insurance] ?? BASE_INSURANCE_BADGE_MAP[Insurance.INSURANCE_NOT_INSURED];
});
</script>
